import Dashboard from "views/Dashboard.js";


var dashRoutes = [
  {
    path: "/",
    name: "",
    icon: "design_app",
    component: Dashboard,
    layout: "/",
  }
];
export default dashRoutes;
